// extracted by mini-css-extract-plugin
export default {"chip":"MUIChip_chip__Sl3WE"};